import React from 'react'
import PDFViewer from '../../components/msi/PdfViewer'
import '../../components/msi/MsiDetail.css'

function ClinicalFaculty() {
  return (
    <div style={{ paddingTop: '150px', paddingBottom: '40px', display: 'flex', justifyContent: 'center', background: '#fff', minHeight: '100vh' }}>
      <div style={{ width: '820px', maxWidth: '100%' }}>
        <PDFViewer file='clinical.pdf'/>
      </div>
    </div>
  )
}

export default ClinicalFaculty
